import axios from 'axios'
import {JwtToken} from "@/utils/jwt";

export default class InstallationsService {

    getElectricityDataComparisonBetweenYears(baseYear, targetYear) {
        // return axios.get('assets/layout/data/electricity-year-over-year.json').then(res => res.data);
        return Promise.all([
            axios.get(`/api/customers/${JwtToken.fromLocalStorage().organizationId()}/installations/statistics?year=${baseYear}`),
            axios.get(`/api/customers/${JwtToken.fromLocalStorage().organizationId()}/installations/statistics?year=${targetYear}`),
            axios.get(`/api/v4/organizations/${JwtToken.fromLocalStorage().organizationId()}`)
        ])
            .then(results => {
                const baseYearUsage = results[0].data[2].usage;
                const tagetYearUsage = results[1].data[2].usage;
                const baseYearElectricityIndex = Math.round(baseYearUsage / results[2].data.facilitiesTotalArea);
                const targetYearElectricityIndex = Math.round(tagetYearUsage / results[2].data.facilitiesTotalArea);

                return [{
                    year: baseYear,
                    consumption: baseYearUsage,
                    co2Emissions: results[0].data[2].co2,
                    facilitiesTotalArea: results[2].data.facilitiesTotalArea,
                    electricityIndex: baseYearElectricityIndex,
                    electricityIndexImage:this.pickElectricityIndexImage(baseYearElectricityIndex, results[2])
                }, {
                    year: targetYear,
                    consumption: tagetYearUsage,
                    co2Emissions: results[1].data[2].co2,
                    facilitiesTotalArea: results[2].data.facilitiesTotalArea,
                    electricityIndex: targetYearElectricityIndex,
                    electricityIndexImage:this.pickElectricityIndexImage(targetYearElectricityIndex, results[2])
                }]
            });
    }

    pickElectricityIndexImage(electricityIndex, organizationData) {
        const ordinaryScale = [20, 32, 44, 56, 68, 80];
        const paintshopScale = [40, 58, 76, 94, 112, 130];
        let scale;
        if (organizationData.data.departments.some(x => x.type.name.includes("Malerværksted")) || organizationData.data.departments.some(x => x.type.name.includes("Undervognsværksted"))) {
            scale = paintshopScale;
        } else {
            scale = ordinaryScale;
        }
        if (electricityIndex < scale[0] ) {
            return "/assets/icons/electricityIndex/Electricity A.gif" ;
        } else if (electricityIndex < scale[1]) {
            return "/assets/icons/electricityIndex/Electricity B.gif" ;
        } else if (electricityIndex < scale[2]) {
            return "/assets/icons/electricityIndex/Electricity C.gif" ;
        } else if (electricityIndex < scale[3]) {
            return "/assets/icons/electricityIndex/Electricity D.gif" ;
        } else if (electricityIndex < scale[4]) {
            return "/assets/icons/electricityIndex/Electricity E.gif" ;
        } else if (electricityIndex < scale[5]) {
            return "/assets/icons/electricityIndex/Electricity F.gif" ;
        } else {
            return "/assets/icons/electricityIndex/Electricity G.gif" ;
        }
    }

    getHeatingDataComparisonBetweenYears(baseYear, targetYear) {
        return Promise.all([
            axios.get(`/api/customers/${JwtToken.fromLocalStorage().organizationId()}/installations/statistics?year=${baseYear}`),
            axios.get(`/api/customers/${JwtToken.fromLocalStorage().organizationId()}/installations/statistics?year=${targetYear}`),
            axios.get(`/api/v4/organizations/${JwtToken.fromLocalStorage().organizationId()}`)
        ])
            .then(results => {
                const unitConversionLtrOilToKwh = 10;
                const unitConversionMwhToKwh = 1000;
                const unitConversionNatGasm3T0Kwh = 11.75;
                const unitConversionKwhToMj = 3.6;

                const oilBaseYear = unitConversionLtrOilToKwh*results[0].data[1].usage;
                const remoteHeatBaseYear = unitConversionMwhToKwh * results[0].data[3].usage;
                const natGasBaseYear = unitConversionNatGasm3T0Kwh * results[0].data[4].usage;
                const totalHeatBaseYear=oilBaseYear + remoteHeatBaseYear + natGasBaseYear;

                const correctedOilBaseYear = unitConversionLtrOilToKwh*results[0].data[1].correctedUsage;
                const correctedRemoteHeatBaseYear = unitConversionMwhToKwh * results[0].data[3].correctedUsage;
                const correctedNatGasBaseYear = unitConversionNatGasm3T0Kwh * results[0].data[4].correctedUsage;
                const correctedTotalHeatBaseYear=correctedOilBaseYear + correctedRemoteHeatBaseYear + correctedNatGasBaseYear;

                const oilTargetYear = unitConversionLtrOilToKwh * results[1].data[1].usage;
                const remoteHeatTargetYear = unitConversionMwhToKwh * results[1].data[3].usage;
                const natGasTargetYear = unitConversionNatGasm3T0Kwh * results[1].data[4].usage;
                const totalHeatTargetYear=oilTargetYear + remoteHeatTargetYear + natGasTargetYear;

                const correctedOilTargetYear = unitConversionLtrOilToKwh * results[1].data[1].correctedUsage;
                const correctedRemoteHeatTargetYear = unitConversionMwhToKwh * results[1].data[3].correctedUsage;
                const correctedNatGasTargetYear = unitConversionNatGasm3T0Kwh * results[1].data[4].correctedUsage;
                const correctedTotalHeatTargetYear=correctedOilTargetYear + correctedRemoteHeatTargetYear + correctedNatGasTargetYear;
                
                const baseYearHeatIndex = Math.round(unitConversionKwhToMj * totalHeatBaseYear / results[2].data.facilitiesTotalArea);
                const targetYearHeatIndex = Math.round(unitConversionKwhToMj * totalHeatTargetYear / results[2].data.facilitiesTotalArea);

                return [{
                    year: baseYear,
                    consumption: unitConversionKwhToMj * totalHeatBaseYear,
                    adjustedConsumption: unitConversionKwhToMj * correctedTotalHeatBaseYear,
                    co2Emissions: results[0].data[1].co2 + results[0].data[3].co2 + results[0].data[4].co2,
                    facilitiesTotalArea: results[2].data.facilitiesTotalArea,
                    heatIndex: baseYearHeatIndex,
                    heatIndexImage:this.pickHeatIndexImage(baseYearHeatIndex, results[2])
                    
                }, {
                    year: targetYear,
                    consumption: unitConversionKwhToMj * totalHeatTargetYear,
                    adjustedConsumption: unitConversionKwhToMj * correctedTotalHeatTargetYear,
                    co2Emissions: results[1].data[1].co2+results[1].data[3].co2+results[1].data[4].co2,
                    facilitiesTotalArea: results[2].data.facilitiesTotalArea,
                    heatIndex: targetYearHeatIndex,
                    heatIndexImage:this.pickHeatIndexImage(targetYearHeatIndex, results[2])
                }]
            });
    }

    pickHeatIndexImage(heatIndex, organizationData) {
        const ordinaryScale = [50, 140, 230, 320, 410, 500];
        const paintshopScale = [100, 280, 460, 640, 820, 1000];
        let scale;
        if (organizationData.data.departments.some(x => x.type.name.includes("Malerværksted")) || organizationData.data.departments.some(x => x.type.name.includes("Undervognsværksted"))) {
            scale = paintshopScale;
        } else {
            scale = ordinaryScale;
        }
        if (heatIndex <scale[0] ) {
            return "/assets/icons/heatIndex/Heat A.gif" ;
        } else if (heatIndex < scale[1]) {
            return "/assets/icons/heatIndex/Heat B.gif" ;
        } else if (heatIndex < scale[2]) {
            return "/assets/icons/heatIndex/Heat C.gif" ;
        } else if (heatIndex < scale[3]) {
            return "/assets/icons/heatIndex/Heat D.gif" ;
        } else if (heatIndex < scale[4]) {
            return "/assets/icons/heatIndex/Heat E.gif" ;
        } else if (heatIndex < scale[5]) {
            return "/assets/icons/heatIndex/Heat F.gif" ;
        } else {
            return "/assets/icons/heatIndex/Heat G.gif" ;
        }
    }

    getWaterDataComparisonBetweenYears(baseYear, targetYear) {
        return Promise.all([
            axios.get(`/api/customers/${JwtToken.fromLocalStorage().organizationId()}/installations/statistics?year=${baseYear}`),
            axios.get(`/api/customers/${JwtToken.fromLocalStorage().organizationId()}/installations/statistics?year=${targetYear}`),
            axios.get(`/api/v1/installations/consumption?for=washing&year=${baseYear}`),
            axios.get(`/api/v1/installations/consumption?for=washing&year=${targetYear}`)
        ])
            .then(results => {

                const baseYearWashing = results[2].data.find(x => x.clientId === JwtToken.fromLocalStorage().organizationId()).washing;
                const targetYearWashing = results[3].data.find(x => x.clientId === JwtToken.fromLocalStorage().organizationId()).washing;

                return [{
                    year: baseYear,
                    consumption: results[0].data[0].usage,
                    carwashCount: baseYearWashing === undefined ? undefined : baseYearWashing.amount
                }, {
                    year: targetYear,
                    consumption: results[1].data[0].usage,
                    carwashCount: targetYearWashing === undefined ? undefined : targetYearWashing.amount
                }]
            });
    }

    getWasteDataComparisonBetweenYears(baseYear, targetYear) {
        return axios.get('/api/v4/installations/disposals')
            .then(results => {

                const keyExtractor = x => x.supply.type.name;
                const baseYearValueExtractor = x => x.registrations
                    .filter(r => r.registrationPeriod.year === baseYear)
                    .map(x => x.reading);
                const targetYearValueExtractor = x => x.registrations
                    .filter(r => r.registrationPeriod.year === targetYear)
                    .map(x => x.reading);

                const baseYearGroups = results.data.groupBy(keyExtractor, baseYearValueExtractor);
                const targetYearGroups = results.data.groupBy(keyExtractor, targetYearValueExtractor);

                for (const key of baseYearGroups.keys()) {
                    baseYearGroups.set(key, baseYearGroups.get(key).reduce((a, b) => a + b, 0));
                }
                for (const key of targetYearGroups.keys()) {
                    targetYearGroups.set(key, targetYearGroups.get(key).reduce((a, b) => a + b, 0));
                }

                return [{
                    year: baseYear,
                    consumptionByCategory: baseYearGroups
                }, {
                    year: targetYear,
                    consumptionByCategory: targetYearGroups
                }]
            });
    }

    getMonthlyElectricityConsumption(year) {
        // return axios.get(`assets/layout/data/electricity-monthly-${year}.json`).then(res => res.data);
        return axios.get(`/api/customers/${JwtToken.fromLocalStorage().organizationId()}/installations/statistics?year=${year}`)
            .then(result => result.data[2].chartArray);
    }

    getMonthlyHeatingConsumption(year) {
        return axios.get(`/api/customers/${JwtToken.fromLocalStorage().organizationId()}/installations/statistics?year=${year}`)
            .then(result => {
                const oilUsage = result.data[1].chartArray.map(value => value * 10 / 1000);
                const remoteHeatUsage = result.data[3].chartArray.map(value => value );
                const natGasUsage = result.data[4].chartArray.map(value => value * 11.75 / 1000);
                const totalHeatUsage= new Array(12);
                for (let i=0 ; i<12; i++) {
                    totalHeatUsage[i]=oilUsage[i]+remoteHeatUsage[i]+natGasUsage[i];
                }
                return totalHeatUsage
            });
    }

    getMonthlyWaterConsumption(year) {
        return axios.get(`/api/customers/${JwtToken.fromLocalStorage().organizationId()}/installations/statistics?year=${year}`)
            .then(result => result.data[0].chartArray);
    }

    getYearlyWasteConsumption(year) {
        return axios.get('/api/v4/installations/disposals')
            .then(result => {

                const keyExtractor = x => x.supply.type.name;
                const valueExtractor = x => x.registrations
                    .filter(r => {
                        return r.registrationPeriod.year === year
                    })
                    .map(x => x.reading);

                const groups = result.data.groupBy(keyExtractor, valueExtractor, true);

                return new Map([...groups].map(group => {
                    return [group[0], group[1].reduce((x, y) => x + y, 0)]
                }));
            });
    }
}